/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderLocatorAliases {
  AVATAR_0 = 'avatar-0',
  BUTTON_CONFIRM = 'button-confirm',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_PROVIDERS = 'deck-providers',
  FETCH_PROVIDERS = 'fetch-providers',
  FIELD_AVATAR = 'field-avatar',
  FIELD_BENEF = 'field-benef',
  FIELD_NOME_SOCIAL = 'field-nome-social',
  FILTER_PROVIDERS = 'filter-providers',
  FILTERED_LIST_PROVIDERS = 'filtered-list-providers',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  HPMS_CUSTOM_CARD_PROVIDERS = 'hpms-custom-card-providers',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  MAPPER_0 = 'mapper-0',
  PANEL_LOCATOR_PROVIDERS = 'panel-locator-providers',
}
export { ProviderLocatorAliases };
